import React from "react";
import Posts from "./Posts";

const Home = () => {
  return (
    <>
      <div className="container">
        <div className="row mt-5">
          <div className="col-sm-2">
            <p>
              <i
                className="fas fa-graduation-cap"
                style={{ color: "#8D0E0E", fontSize: "25px" }}
              ></i>
              <span className="text-white font-weight-bold">
                LEARN <br />
                WITH US
              </span>
            </p>
          </div>
          <div className="col-sm-10 mb-5">
            <Posts />
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
